import { render } from "./LeftBar.vue?vue&type=template&id=deefe5a6&scoped=true"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"

import "./LeftBar.vue?vue&type=style&index=0&id=deefe5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deefe5a6"]])

export default __exports__